<template>
    <section class="fixed-icon"
             :style="{ bottom: bottom + 'rem' }"
             :class="[ !transition ? 'fixed-transition' : '']"
             @click="event">
        <slot></slot>
    </section>
</template>
<script>
import { isIos, isAndroid } from '../utils/device'
  export default {
    name: 'fixedIcon',
    props: {
      disport:{},
      bottom: { // 改图标距离底部距离 单位 rem
        type: Number,
        default: 3,
      },
    },
    data () {
      return {
        transition: true, // 是否触发动画
        timer: null, // 定时器
      };
    },
    methods: {
      event() {
        // window.location.href = 'https://javaapi.cardsvault.net:8060/blindboxs/TurntableView?drawPrizeId=5&token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJDSEFPWElOWElORyNBUFAiLCJhdWQiOiJDSEFPWElOWElORyIsIm5iZiI6MTczNjEyODc5NCwiZGF0YSI6IjYiLCJpc3MiOiI3ViNweHlQZSIsImV4cCI6MTczNjI0ODc5NCwiaWF0IjoxNzM2MTI4Nzk0LCJqdGkiOiJlYjFlOTI0Yy1jNjc2LTQyOWMtODRkNS1lOWQ5ZjEzNzMzYTkifQ.Qk5kgrHmTSZcCdLxSkiLMezkA7SW5K9Yj0TKbNCBF_A'
        // this.disport.activeLink
        if(isIos()) {
          window.webkit.messageHandlers.iOSCall.postMessage({
            action: "prizedrawClick",
            data: {
              url: this.disport.activeLink
            }
          })
        }else if(isAndroid()) {
          let par = {
            url: this.disport.activeLink
          }
          window.android.prizedrawClick(JSON.stringify(par))
        } else {
          console.log('other')
        }
        // this.$emit('clickEvent'); // 绑定点击图表时间
        // this.$router.push({name: 'TurntableView'})
      },
      handleScroll () { // 每次滑动都会执行函数
        this.transition = false;
        if (this.timer) { // 判断是否已存在定时器
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => { // 创建定时器，1.4s后图标回归原位置
          this.transition = true;
        }, 500);
      }
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll); // 监听页面滑动
    }
  };
</script>

<style scoped lang="scss">
    /*@media only screen and (min-width:750px){html{font-size:20px}} */
    .fixed-icon{
        position: fixed;
        z-index: 1;
        top:5.3rem;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        height: .7rem;
        width: .7rem;
        border-radius: 50%;
        background:url('https://mq-test-vault.oss-cn-beijing.aliyuncs.com/cxx/prod/temp/%E6%8A%BD%E5%A5%96%E5%85%A5%E5%8F%A3.png') no-repeat;
        background-size: 100% 100%;
        transition: 0.7s ease-in-out;
        margin-right:-.2rem;
    }
    .fixed-transition{
        right: -.4rem;
        opacity: 0.4;
        transition: 1s ease-in-out;
    }
</style>
